export const PhaseTypeEnum = [
  'MELT',
  'ANNEAL'
];